import * as React from 'react';
import { IDropdownData } from 'models/common';
import { imgSrcAttributes } from 'helpers/common';
import { PortalFieldLabel } from '../PortalFieldLabel';
const classNames = require('classnames');

interface IProps<
	TValue = string,
	TKey extends string | number = string,
	TItem extends IDropdownData<TValue, TKey> = IDropdownData<TValue, TKey>,
> {
	input?: any;
	name?: string;
	items?: TItem[];
	meta?: any;
	description?: string;
	isDisabled?: boolean;
	onChangeAction?: (arr: TKey[]) => any;
}

class MultiCheckboxField<
	TValue = string,
	TKey extends string | number = string,
	TItem extends IDropdownData<TValue, TKey> = IDropdownData<TValue, TKey>,
> extends React.Component<IProps<TValue, TKey, TItem>> {
	public render() {
		const { name, onChange, onBlur, onFocus, isDisabled } = this.props.input;
		const { input, items, meta, onChangeAction } = this.props;
		const inputValue = input.value;

		let description = this.props.description;
		let status = '';
		if (meta?.touched) {
			if (meta?.warning) {
				status = 'withWarning';
				description = meta.warning;
			}
			if (meta?.error) {
				description = meta.error;
				status = 'withError';
			}
		}

		const checkboxes = items.map(({ key, value, image }, index) => {
			const handleChange = (event) => {
				let arr: any = [...inputValue];
				if (arr === '') {
					arr = [];
				}
				if (event.target.checked) {
					arr.push(key);
				} else {
					arr.splice(arr.indexOf(key), 1);
				}
				onBlur(arr);
				if (onChangeAction) {
					onChangeAction(arr);
				}
				return onChange(arr);
			};
			const checked = inputValue.includes(value);

			let imageEl: any = '';
			if (image !== undefined) {
				imageEl = <img {...imgSrcAttributes(image)} style={{ width: 50, height: 50 }} />;
			}

			return (
				<label key={`div-${index}`} className="checkboxHolder">
					<input
						className={meta?.touched && meta?.error ? 'inputError' : ''}
						type="checkbox"
						name={`${name}[${index}]`}
						value={key}
						checked={checked}
						onChange={handleChange}
						onFocus={onFocus}
						disabled={isDisabled}
					/>
					<PortalFieldLabel text={value} tag="div" />
					{imageEl}
				</label>
			);
		});

		return (
			<div className={classNames('fieldGroup multiCheckbox', status)}>
				<div className="checkboxes">{checkboxes}</div>
				{description ? <span className="note">{description}</span> : null}
			</div>
		);
	}
}

export { MultiCheckboxField };
